import React from 'react';
import { CONFIG } from '../../../../environments';
import { hasSpecificHtmlContent, parseDomFromString } from '../../../../utils';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, CTA_ACTION_CATEGORY } from '../../../../constants';
import DisclaimerText from '../../global/DisclaimerText';

const Card = (props) => {
  const { image, title, description, buyButtonLink, price, index,
    disclaimer, disclaimerInfo, disclaimerIsBlackColor, disclaimerOption,
    disclaimerIsTypeInfo } = props;
  const { buyButtonText } = window.HONDA_SHOP_ACCESSORIES;
  const hoverClassName = image ? 'img-hover-scale' : '';
  const safeDescription = parseDomFromString(description);
  return (
    <div className={`h-full anima-bottom-v1 delay-ins-${index}`}>
      <div className={`relative rounded h-full bg-white pb-17 md:pb-9 2xl:pb-19 ${hoverClassName}`}>
        <div className="relative overflow-hidden rounded-t pb-[73.1%] mb-12 md:pb-[65.5%] md:mb-8 lg:pb-[58.2%] 2xl:pb-[66.1%] 2xl:mb-12 1k6:pb-[58.3%] 1k6:mb-8">
          {image &&
            <img loading="lazy" src={CONFIG.ENDPOINT_IMAGE.concat(image)} alt={title} className="absolute inset-0 w-full h-full object-cover" />
          }
          {disclaimer &&
            <div className="bg-black">
              <DisclaimerText disclaimer={disclaimer}
                disclaimerInfo={disclaimerInfo}
                disclaimerColor={disclaimerIsBlackColor}
                disclaimerOption={disclaimerOption}
                isTypeInfo={disclaimerIsTypeInfo} />
            </div>
          }
        </div>

        <div className="px-12">
          <div className="text-font-14-17 text-gray-650 last-mb-none mb-4p5">
            <p>${price}</p>
          </div>

          <h3 className="h6 font-semibold mb-4 md:text-h6 md:font-bold 2xl:text-h5 2xl:mb-8 1k6:text-h6 1k6:mb-4">{title}</h3>
          {hasSpecificHtmlContent(safeDescription) &&
            <div className="last-mb-none mb-11 2xl:mb-11 1k6:mb-10" dangerouslySetInnerHTML={{ __html: safeDescription }} />
          }
          {!hasSpecificHtmlContent(safeDescription) &&
            <div className="last-mb-none mb-11 2xl:mb-11 1k6:mb-10">
              <p className="mb-0">{safeDescription}</p>
            </div>
          }

          <span className="btn btn-text-primary m-0">
            <span className="text">{buyButtonText}</span>
          </span>
        </div>

        <a href={buyButtonLink} className="no-underline absolute inset-0 z-1" target="_blank" rel="noopener noreferrer"
          data-event-trigger={CLICK_EVENT_TRIGGER}
          data-event-type={CLICK_EVENT_ACTION_TYPE}
          data-event-module="shop accessories"
          data-event-label={title}
          data-event-category={CTA_ACTION_CATEGORY}>
          <span className="sr-only">{title}</span>
        </a>
      </div>
    </div>
  );
};

export default Card;